import React from 'react';
import { MdSearch, MdClose, MdPerson } from 'react-icons/md';
import VerifiedBadge from '../../components/VerifiedBadge';

function RepSearchBar({
  searchQuery,
  searchResults,
  searching,
  showDropdown,
  searchRef,
  onSearchChange,
  onSelectResult,
  onClearSearch,
  onFocus,
}) {
  return (
    <div className="mb-8" ref={searchRef}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <MdSearch className="text-xl text-gray-400" />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchChange}
          onFocus={onFocus}
          placeholder="Search representatives by name..."
          className="w-full pl-12 pr-12 py-4 text-lg rounded-xl border border-gray-300 focus:ring-2 focus:ring-primary focus:border-primary transition-all"
          data-testid="rep-search-input"
        />
        {searchQuery && (
          <button
            onClick={onClearSearch}
            className="absolute inset-y-0 right-0 pr-4 flex items-center"
          >
            <MdClose className="text-xl text-gray-400 hover:text-gray-600" />
          </button>
        )}

        {/* Search Dropdown */}
        {showDropdown && searchResults.length > 0 && (
          <div className="absolute z-50 w-full mt-2 bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
            {searchResults.map((rep) => (
              <button
                key={rep.profile_id}
                onClick={() => onSelectResult(rep)}
                className="w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors text-left"
                data-testid={`search-result-${rep.profile_id}`}
              >
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
                  {rep.profile_picture_url ? (
                    <img src={rep.profile_picture_url} alt={rep.name} className="w-full h-full object-cover" />
                  ) : (
                    <MdPerson className="text-xl text-gray-400" />
                  )}
                </div>
                <div className="flex-grow min-w-0">
                  <p className="font-medium text-gray-900 truncate flex items-center gap-1">
                    {rep.name}
                    <VerifiedBadge status={rep.verification_status} />
                  </p>
                  <p className="text-sm text-gray-500 truncate">
                    {rep.office} &bull; {rep.office_level}
                    {rep.running_location && ` \u2022 ${rep.running_location}`}
                  </p>
                </div>
              </button>
            ))}
          </div>
        )}

        {/* Searching indicator */}
        {searching && (
          <div className="absolute z-50 w-full mt-2 bg-white rounded-xl shadow-lg border border-gray-200 p-4 text-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto"></div>
          </div>
        )}

        {/* No results */}
        {showDropdown && !searching && searchQuery.length >= 2 && searchResults.length === 0 && (
          <div className="absolute z-50 w-full mt-2 bg-white rounded-xl shadow-lg border border-gray-200 p-4 text-center text-gray-500">
            No representatives found matching &quot;{searchQuery}&quot;
          </div>
        )}
      </div>
    </div>
  );
}

export default RepSearchBar;
